import { render, staticRenderFns } from "./RewardCoin.vue?vue&type=template&id=3f96bcd0&scoped=true&"
import script from "./RewardCoin.vue?vue&type=script&lang=ts&"
export * from "./RewardCoin.vue?vue&type=script&lang=ts&"
import style0 from "./RewardCoin.vue?vue&type=style&index=0&id=3f96bcd0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96bcd0",
  null
  
)

export default component.exports